<waitLoading *ngIf="!isLoaded()"></waitLoading>
<ng-container *ngIf="isLoaded()">
  <h3>{{ 'AwardCriteria.title' | translate }}</h3>
  <p-table [value]="projectAwardCriterias" [responsive]="true">
    <ng-template pTemplate="header">
      <tr>
        <th [style.width]="'10%'">{{ colHeaders[0] | translate }}</th>
        <th [style.width]="'25%'">{{ colHeaders[1] | translate }}</th>
        <th [style.width]="'10%'">{{ colHeaders[2] | translate }}</th>
        <th [style.width]="'25%'">{{ colHeaders[3] | translate }}</th>
        <th [style.width]="'20%'">{{ colHeaders[4] | translate }}</th>
        <th [style.width]="'20%'">{{ colHeaders[5] | translate }}</th>
        <!--th [style.width]="'10%'">{{ colHeaders[6] | translate }}</!--th-->
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-lote>
      <tr *ngFor="let criteria of lote.selectionAwardCriteria ; index as i;">
        <td>
          <span class="p-column-title">{{ colHeaders[0] | translate }}</span>{{ lote.lotNumber }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{ criteria.name }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[2] | translate }}</span> {{ criteria.weight }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[3] | translate }}</span>
          <span *ngIf="criteria.direction" class="d-block">{{ 'AwardCriteria.edit.direction.text' | translate }}: {{
            ('AwardCriteria.edit.direction.' + criteria.direction) | translate }} </span>
          <span *ngIf="criteria.satisfactionThreshold" class="d-block">{{ 'AwardCriteria.edit.satisfactionThreshold' |
            translate }}: {{ criteria.satisfactionThreshold }} </span>
          <span *ngIf="criteria.satietyThreshold" class="d-block">{{ 'AwardCriteria.edit.satietyThreshold' | translate
            }}: {{ criteria.satietyThreshold }} </span>
          <span *ngIf="criteria.valuationFactor" class="d-block">{{ 'AwardCriteria.edit.valuationFactor' | translate }}:
            {{ criteria.valuationFactor }} </span>
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[4] | translate }}</span>
          <span *ngIf="criteria.formula">{{ criteria.formula.description }}</span>
        </td>
        <!--td>
          <span class="p-column-title">{{ colHeaders[5] | translate }}</span>
          <span *ngIf="criteria.transferPriceOffer !== null && criteria.transferPriceOffer !== undefined">
            {{ getDumpPriceOptionLabel(criteria.transferPriceOffer) || 'AwardCriteria.transferPriceOffer.no' | translate
            }}
          </span>
        </td-->
        <td>
          <span class="p-column-title">{{ colHeaders[5] | translate }}</span>
          <div class="btn-group">
            <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
              (click)="editData(createBean(criteria,lote))" title="{{ 'General.edit' | translate}}" appNoDblClick
              *ngIf="criteria.awardingCriteriaTypeCode">
              <i class="fas fa-pencil-alt" aria-hidden="true"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td colspan="3"><span>{{ 'General.noData' | translate }}</span></td>
      </tr>
    </ng-template>
  </p-table>
  <!--div class="flex-row py-2">
    <div class="d-flex flex-row">
      <button class="btn btn-sm btn-secondary" (click)="openFormulas();" appNoDblClick>
        <i class="fas fa-calculator"></i> {{ 'AwardCriteria.adm' | translate }}
      </button>
    </div>
  </div-->
</ng-container>